<script>
import { THIRD_LEVEL_MENU } from './config/BCconstants.js'
import TransparentButton from "./atoms/TransparentButton.vue";

export default {
  name: 'BCOptionalFeaturesPasswordSettings',
    components: {TransparentButton},
  props: {
      first: {
          type: String,
          required: true
      },
      second: {
          type: String,
          required: true
      },
      setting: {
          type: Object,
          required: false,
      },
  },
  data() {
    // json第一階層
    const firstLevel = this.first
    // json第二階層
    const secondLevel = this.second
    // json第三階層の項目名
    const transceiverPassword = THIRD_LEVEL_MENU[firstLevel][secondLevel][0].item[0]
    const extendedMenuPassword = THIRD_LEVEL_MENU[firstLevel][secondLevel][0].item[1]
    // パスワード未設定時の表示内容
    const pswdUnset = '設定なし'
    const passwordSetting = (this.setting[firstLevel] && this.setting[firstLevel][secondLevel]) || {}

    // 初期値
    const txPswd = passwordSetting[transceiverPassword.name]
    const extendPswd = passwordSetting[extendedMenuPassword.name]

    return {
      firstLevel,
      secondLevel,
      transceiverPassword,
      extendedMenuPassword,
      pswdUnset,
      dataPwd: [
        {
          label: transceiverPassword.label,
          value: this.hasPassword(txPswd) ? this.hidePassword(txPswd) : pswdUnset,
          password: txPswd,
          showPassword: this.hasPassword(txPswd),
          visible: false,
        },
        {
          label: extendedMenuPassword.label,
          value: this.hasPassword(extendPswd) ? this.hidePassword(extendPswd) : pswdUnset,
          password: extendPswd,
          showPassword: this.hasPassword(extendPswd),
          visible: false,
        },
      ],
    }
  },
  methods: {
    hasPassword(value) {
      return value !== undefined && value !== null && value !== ''
    },
    // パスワードを隠す
    hidePassword(value) {
      return String(value).replace(/./g, '●')
    },
    // 表示・非表示アイコン及びパスワードの値の切替え
    toggleIcon(row) {
      if (!row.showPassword) {
        return
      }
      row.visible = !row.visible
      row.value = row.visible ? row.password : this.hidePassword(row.password)
    },
  },
}
</script>

<template>
  <el-table :data="dataPwd">
    <el-table-column prop="label" />
    <el-table-column prop="value" label="設定値" />
    <el-table-column width="100">
        <template v-slot="{ row }">
            <TransparentButton
                v-if="row.showPassword"
                icon-src=""
                :label="row.visible ? 'HIDE' : 'SHOW'"
                class="showHideText"
                @click="toggleIcon(row)"
             />
        </template>
    </el-table-column>
  </el-table>
</template>

<style scoped>

.showHideText :deep(.buttonText) {
    padding: 0;
    font-size: 10px;
    color: #848991;
}

</style>
